import { matchPath } from 'react-router-dom';
import { PageTypes } from 'utils/pageTypes';
import { AppRoutePath } from '../config/constants';

export { ExtWindowName } from './useExtensionState';

export type Tab = {
  type: PageTypes;
  windowId: Nullable<string>;
  url: string;
  worklistIds: string[];
  path: string;
};

export type OpenTabsInfo = {
  tabs: Array<Tab>;
  openedViewerIds: Set<string>;
  isViewerOpen: boolean;
  isViewer0Open: boolean;
  isViewer1Open: boolean;
  isReporterOpen: boolean;
  isWorklistOpen: boolean;
  isSearchOpen: boolean;
  isJacketOpen: boolean;
  isPatientJacketDockedOpen: boolean;
  isPatientJacketUndockedOpen: boolean;
  isAISandboxOpen: boolean;
};

export const computeFlags = (tabs: Array<Tab>): OpenTabsInfo => {
  const openedViewerIds = new Set(
    tabs
      .filter((tab) => tab.type === PageTypes.VIEWER)
      .reduce<string[]>((acc, tab) => (tab.windowId != null ? [...acc, tab.windowId] : acc), [])
  );

  const isViewer0Open = tabs.some((tab) => tab.type === PageTypes.VIEWER && tab.windowId === '0');
  const isViewer1Open = tabs.some((tab) => tab.type === PageTypes.VIEWER && tab.windowId === '1');
  const isViewerOpen =
    isViewer0Open || isViewer1Open || tabs.some((t) => t.type === PageTypes.VIEWER);
  const isReporterOpen = tabs.some((tab) => tab.type === PageTypes.REPORTER);
  const isWorklistOpen = tabs.some(
    (tab) => tab.type === PageTypes.WORKLIST && !tab.path.includes(AppRoutePath.WORKLIST_SEARCH)
  );
  const isSearchOpen = tabs.some((tab) => tab.path.includes(AppRoutePath.WORKLIST_SEARCH));
  const isPatientJacketDockedOpen = tabs.some(
    (tab) => matchPath(AppRoutePath.PATIENT_JACKET, tab.path) != null
  );
  const isPatientJacketUndockedOpen = tabs.some((tab) => tab.type === PageTypes.PATIENT_JACKET);
  const isJacketOpen = isPatientJacketDockedOpen || isPatientJacketUndockedOpen;
  const isAISandboxOpen = tabs.some((tab) => tab.type === PageTypes.AI_SANDBOX);

  return {
    tabs,
    openedViewerIds,
    isViewerOpen,
    isViewer0Open,
    isViewer1Open,
    isReporterOpen,
    isWorklistOpen,
    isSearchOpen,
    isJacketOpen,
    isPatientJacketDockedOpen,
    isPatientJacketUndockedOpen,
    isAISandboxOpen,
  };
};
